const config = {
    // The title to display in the App header.
    appName: 'Swarthmore Course iCal Tool',
    // The API url.
    apiUrl: 'https://secure.swarthmore.edu/trico-course-guide/courses.json',
    // The current semestesr.
    semester: 'fall_2021'
}

export default config;
